<template>
  <div id="menu-container" class="collapse collapse-nav-only menu">
    <MenuItems v-if="menu.items" :items="menu.items" :top="true" id="menu-top" />
    <span v-else class="fal fa-spinner fa-spin" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      menu: state => state.global.menu
    })
  }
};
</script>

<style>
</style>
